import React, { useState, useEffect, useRef } from "react";
import { Snackbar, Alert } from "@mui/material";

const MicTestSection = ({ onNext }) => {
  const [permission, setPermission] = useState(null);
  const [level, setLevel] = useState(0);
  const [speaking, setSpeaking] = useState(false);
  const [count, setCount] = useState(10);
  const [allowNext, setAllowNext] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);

  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const streamRef = useRef(null);
  const rafRef = useRef(null);
  const countdownRef = useRef(null);
  const micPassedRef = useRef(false);

  useEffect(() => {
    async function setupMic() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        setPermission(true);
        streamRef.current = stream;

        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioContextRef.current = audioContext;

        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 256;
        analyserRef.current = analyser;

        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);

        const dataArray = new Uint8Array(analyser.frequencyBinCount);

        const updateVolume = () => {
          analyser.getByteFrequencyData(dataArray);
          const avg = dataArray.reduce((s, v) => s + v, 0) / dataArray.length;
          const micLevel = Math.min(100, Math.round(avg));

          setLevel(micLevel);

          // Track if mic crossed threshold
          if (micLevel >= 50) {
            micPassedRef.current = true;
          }

          rafRef.current = requestAnimationFrame(updateVolume);
        };

        updateVolume();
      } catch (err) {
        setPermission(false);
      }
    }

    setupMic();

    return () => {
      cancelAnimationFrame(rafRef.current);
      countdownRef.current && clearInterval(countdownRef.current);
      if (audioContextRef.current) audioContextRef.current.close();
      if (streamRef.current)
        streamRef.current.getTracks().forEach((t) => t.stop());
    };
  }, []);

   const startSpeaking = () => {
      setSpeaking(true);
      setCount(10);
      setAllowNext(false);
      setErrorOpen(false);
      micPassedRef.current = false;

      countdownRef.current = setInterval(() => {
        setCount((prev) => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);

            if (micPassedRef.current) {
              setAllowNext(true);
            } else {
              setSpeaking(false);
              setAllowNext(false);
              setErrorOpen(true);
            }

            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

  return (
    <>
      <div className="language-left-section" style={{gap:'11px'}}>
        <img src="/images/microphone-gray-icon.svg" alt="" width={37} height={49} />
        <h4>Test your mic</h4>
        <p style={{marginTop:'8px'}}>Click the microphone button and speak the sentence above the button</p>
        {permission === null && <p>Requesting microphone permission...</p>}
        {permission === false && <p className="error">Microphone access denied. Please enable mic permissions.</p>}
      </div>
      <div className="language-right-section">
        {!speaking && <img className="quote" src="/images/quote-filled.svg" alt="" />}
        <p>Gappeo is one of the finest AI Assessments product</p>
        {speaking ? 
        <div className="wight-mic-bg">
          <img className="mic-img" src="/images/reddot-img.svg" alt="" width={71} height={71} />
        </div>
        : 
        <div className="wight-mic-bg" onClick={startSpeaking}>
          <img className="mic-img" src="/images/mic-icon.svg" alt="" width={56} height={56} />
        </div>
        }
        <div>
          {speaking && <h3>Speak now</h3>}
          {speaking && <h3>{count}</h3>}
        </div>
        <div className="controls">
          {count === 0 && allowNext && ( <button className="primary" onClick={onNext} disabled={permission === false}>Next</button>)}
        </div>
      </div>
      <Snackbar
        open={errorOpen}
        autoHideDuration={3000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setErrorOpen(false)} sx={{ width: "100%" }}>
          Your voice is very low, can you speak louder into the mic
        </Alert>
      </Snackbar>
    </>
  );
};

export default MicTestSection;
